import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
} from '@mui/material';

const DataSocialResCard = (props) => {
    const { classes, item } = props;

    const socialInfo = item.actualData;
    // item.actualData;

    return (
        <>
            <Card
                classes={{ root: classes.paperContent }}
                sx={{ width: '100%' }}>
                <CardContent sx={{ p: 2 }} className={classes.cardContent}>
                    <Box className={classes.rowContent}>
                        {socialInfo
                            ? socialInfo.options.map((socialRes, index) => {
                                if (socialRes.masterID == socialInfo.masterID) {
                                    return (
                                        <>
                                                <Box
                                                    sx={{
                                                        width: '180px',
                                                        flexBasis: '180px',
                                                        flexGrow: 1,
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'left',
                                                            alignItems: 'left',
                                                        }}>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            color="primary">
                                                            Title
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={14}
                                                            fontWeight={400}>
                                                            <span>
                                                                {socialRes.title}
                                                            </span>
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        width: '180px',
                                                        flexBasis: '180px',
                                                        flexGrow: 1,
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'left',
                                                            alignItems: 'left',
                                                        }}>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            color="primary">
                                                            Requested Timeslot
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={14}
                                                            fontWeight={400}>
                                                            <span>
                                                                {socialRes.specialRequest}
                                                            </span>
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                {/* <Box
                                                    sx={{
                                                        width: '180px',
                                                        flexBasis: '180px',
                                                        flexGrow: 1,
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'left',
                                                            alignItems: 'left',
                                                        }}>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            color="primary">
                                                            Preference
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={14}
                                                            fontWeight={400}>
                                                            <span>
                                                                {socialRes.preference}
                                                            </span>
                                                        </Typography>
                                                    </Box>
                                                </Box> */}
                                            <Box>
                                                <Box
                                                    sx={{
                                                        width: '570px',
                                                        flexBasis: '570px',
                                                        flexGrow: 1,
                                                        pt:2
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'left',
                                                            alignItems: 'left',
                                                        }}>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={12}
                                                            fontWeight={500}
                                                            color="primary">
                                                            Description
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            fontSize={14}
                                                            fontWeight={400}>
                                                            <span dangerouslySetInnerHTML={{ __html: socialRes.description }} ></span>
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </>
                                    );
                                }

                            })
                            : 'No Social Impact information found'}
                    </Box>                   
                    {[1, 2, 3].map((item) => {
                        return (
                            <Box
                                key={`outfitInfoSpaOther_${item}`}
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                    mb: 1,
                                }}></Box>
                        );
                    })}
                </CardContent>
            </Card>
        </>
    );
};

export default DataSocialResCard;
